module.exports = __webpack_public_path__ + "static/media/sloth.4a0867e8.svg";